import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaCrown, FaCoins, FaCheck } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';
import api from '../api/axios';

function PaymentSuccess() {
  const navigate        = useNavigate();
  const [params]        = useSearchParams();
  const { updateUser }  = useAuth();
  const [status, setStatus] = useState('checking');

  const type    = params.get('type') || 'premium';   // 'premium' ou 'coins'
  const coins   = parseInt(params.get('coins')) || 0;
  const pack    = params.get('pack') || '';

  const isCoins = type === 'coins';

  useEffect(() => {
    const check = async () => {
      try {
        const { data } = await api.get('/auth/me');
        if (data.user) {
          updateUser(data.user);
          // Pour Premium : vérifie le plan
          // Pour Coins : on accepte directement (webhook a déjà crédité)
          if (!isCoins && data.user?.plan !== 'premium') {
            setStatus('pending');
          } else {
            setStatus('confirmed');
          }
        } else {
          setStatus('pending');
        }
      } catch {
        setStatus('pending');
      }
    };
    const timer = setTimeout(check, 2000);
    return () => clearTimeout(timer);
  }, [updateUser, isCoins]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6"
      style={{ background: '#060f09' }}>
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="w-full max-w-sm text-center"
      >
        {status === 'checking' && (
          <>
            <div className="w-16 h-16 rounded-full border-4 border-qfl-gold border-t-transparent animate-spin mx-auto mb-6" />
            <p className="text-white/50 text-sm">Vérification du paiement...</p>
          </>
        )}

        {status === 'confirmed' && isCoins && (
          <>
            <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }}
              transition={{ type: 'spring', stiffness: 300 }}
              className="w-20 h-20 rounded-full mx-auto mb-6 flex items-center justify-center"
              style={{ background: 'linear-gradient(135deg,#f0b429,#c97d08)' }}>
              <FaCoins size={36} style={{ color: '#0d2b1a' }} />
            </motion.div>
            <h1 className="text-3xl font-black text-qfl-gold uppercase tracking-widest mb-2"
              style={{ fontFamily: "'Rajdhani', sans-serif" }}>
              Pièces créditées !
            </h1>
            <p className="text-white/60 text-sm mb-4">
              <span className="text-qfl-gold font-black text-2xl">{coins.toLocaleString()}</span> pièces ont été ajoutées à ton compte.
            </p>
            <p className="text-white/40 text-xs mb-8">Utilise-les pour participer aux tournois et acheter des boosts.</p>
            <button onClick={() => navigate('/shop')}
              className="w-full py-4 rounded-xl font-black text-sm uppercase tracking-widest"
              style={{ background: 'linear-gradient(135deg,#f0b429,#c97d08)', color: '#0d2b1a', fontFamily: "'Rajdhani', sans-serif" }}>
              Retour à la boutique
            </button>
          </>
        )}

        {status === 'confirmed' && !isCoins && (
          <>
            <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }}
              transition={{ type: 'spring', stiffness: 300 }}
              className="w-20 h-20 rounded-full mx-auto mb-6 flex items-center justify-center"
              style={{ background: 'linear-gradient(135deg,#f0b429,#c97d08)' }}>
              <FaCrown size={36} style={{ color: '#0d2b1a' }} />
            </motion.div>
            <h1 className="text-3xl font-black text-qfl-gold uppercase tracking-widest mb-2"
              style={{ fontFamily: "'Rajdhani', sans-serif" }}>
              Premium Activé !
            </h1>
            <p className="text-white/60 text-sm mb-8">
              Ton abonnement est actif. Profite de tous les avantages Premium !
            </p>
            <div className="flex flex-col gap-2 text-left mb-8">
              {['Vies illimitées en Survie', 'Tournois et championnats réservés', 'Badge couronne exclusif', 'Parrainage rémunéré'].map((f) => (
                <div key={f} className="flex items-center gap-2">
                  <FaCheck size={12} className="text-qfl-gold" />
                  <span className="text-white/60 text-sm">{f}</span>
                </div>
              ))}
            </div>
            <button onClick={() => navigate('/')}
              className="w-full py-4 rounded-xl font-black text-sm uppercase tracking-widest"
              style={{ background: 'linear-gradient(135deg,#f0b429,#c97d08)', color: '#0d2b1a', fontFamily: "'Rajdhani', sans-serif" }}>
              Commencer à jouer
            </button>
          </>
        )}

        {status === 'pending' && (
          <>
            <div className="w-20 h-20 rounded-full mx-auto mb-6 flex items-center justify-center"
              style={{ background: 'rgba(240,180,41,0.15)', border: '2px solid rgba(240,180,41,0.4)' }}>
              {isCoins ? <FaCoins size={36} className="text-qfl-gold" /> : <FaCrown size={36} className="text-qfl-gold" />}
            </div>
            <h1 className="text-2xl font-black text-white uppercase tracking-widest mb-2"
              style={{ fontFamily: "'Rajdhani', sans-serif" }}>
              Paiement reçu
            </h1>
            <p className="text-white/60 text-sm mb-8">
              {isCoins
                ? `Tes ${coins.toLocaleString() || ''} pièces seront créditées dans quelques instants. Vérifie tes notifications.`
                : 'Ton compte sera activé dans quelques instants. Vérifie tes notifications.'}
            </p>
            <button onClick={() => navigate('/')}
              className="w-full py-4 rounded-xl font-black text-sm uppercase tracking-widest"
              style={{ background: 'rgba(240,180,41,0.15)', border: '1px solid rgba(240,180,41,0.3)', color: '#f0b429', fontFamily: "'Rajdhani', sans-serif" }}>
              Retour à l'accueil
            </button>
          </>
        )}
      </motion.div>
    </div>
  );
}

export default PaymentSuccess;
